import { Box, FormControl, FormHelperText, FormLabel } from '@chakra-ui/react';
import { Select, type SingleValue } from 'chakra-react-select';

import {
  type SelectOption,
  selectControlStyles,
} from './impersonationModal.utils';

interface ImpersonationClientGroupQuickSelectProps {
  clientSelectOptions: SelectOption<string>[];
  selectedClientOption: SelectOption<string> | undefined;
  onSelectClientGroup: (clientName: string | undefined) => void;
}

export function ImpersonationClientGroupQuickSelect({
  clientSelectOptions,
  selectedClientOption,
  onSelectClientGroup,
}: ImpersonationClientGroupQuickSelectProps) {
  return (
    <FormControl>
      <FormLabel fontSize="sm" fontWeight="semibold">
        Client Group
      </FormLabel>
      <Box>
        <Select<SelectOption<string>, false>
          options={clientSelectOptions}
          value={selectedClientOption ?? null}
          placeholder="Select a client group to view..."
          onChange={(selected: SingleValue<SelectOption<string>>) =>
            onSelectClientGroup(selected?.value)
          }
          isClearable
          data-testid="quick-client-group-select"
          chakraStyles={selectControlStyles}
        />
      </Box>
      <FormHelperText>
        Quickly view the dashboard with a client group&rsquo;s settings.
      </FormHelperText>
    </FormControl>
  );
}
